import React from "react";
import OrderedModuleEditor from "@/components/common/OrderedModuleEditor";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

const Field = ({ label, children, hint }) => (
  <div className="space-y-1">
    <Label className="text-xs text-white/50">{label}</Label>
    {children}
    {hint && <p className="text-[11px] text-white/40">{hint}</p>}
  </div>
);

export default function WhyChoose() {
  return (
    <OrderedModuleEditor
      resource="admin/site/why-choose"
      singular="item"
      title="Why Choose Us"
      subtitle="Drag to reorder the reasons clients choose CAS Media."
      titleKey="title"
      defaultValues={{ order: 1, icon: "", title: "", description: "" }}
      getItemLabel={(it, idx) => it.title || `Item ${idx + 1}`}
      renderPreviewItem={(it, idx) => (
        <div className="flex gap-3 items-start">
          <span className="w-9 h-9 rounded-lg glass flex items-center justify-center text-xs font-mono text-white/70 shrink-0">
            {it.icon || String(idx + 1).padStart(2, "0")}
          </span>
          <div>
            <div className="text-sm font-medium text-white">{it.title || "Untitled"}</div>
            {it.description && <p className="text-xs text-white/50 mt-1 line-clamp-2">{it.description}</p>}
          </div>
        </div>
      )}
      renderInspector={(item, patch) => (
        <>
          <Field label="Icon" hint="e.g. 01, 02, or short mark">
            <Input value={item.icon || ""} onChange={(e) => patch({ icon: e.target.value })} className="bg-black/20 border-white/10 text-white" />
          </Field>
          <Field label="Title">
            <Input value={item.title || ""} onChange={(e) => patch({ title: e.target.value })} className="bg-black/20 border-white/10 text-white" />
          </Field>
          <Field label="Description">
            <Textarea value={item.description || ""} onChange={(e) => patch({ description: e.target.value })} rows={4} className="bg-black/20 border-white/10 text-white" />
          </Field>
        </>
      )}
    />
  );
}
